<template>
    <div>
        <p>Once uploaded, {{ artist.name }} will give you feedback.</p>

        <b-alert variant="danger" :show="hasErrors">
            <ul>
                <li v-for="err in errors" v-bind:key="err[0]">{{ err[0] }}</li>
            </ul>
        </b-alert>

        <div class="form-group mt-4 mb-4">
            <label>What's your artist name?</label>
            <input type="text" class="form-control" v-model="artist_name" required />
            <small class="form-text text-muted">
                If you don't have an artist name yet just use your real name.
            </small>
        </div>

        <div class="form-group mt-4 mb-4">
            <label>What's the name of your track?</label>
            <input type="text" class="form-control" v-model="track_name" required />
            <small class="form-text text-muted">
                If you don't have a name yet, that's OK, but it will help the artist give you better feedback. It also helps
                you identify the track later.
            </small>
        </div>

        <div class="form-group mb-4">
            <label>Please upload your track</label>
            <input type="file" ref="file" @change="onFileChanged($event)" class="form-control-file" accept=".mp3" required />
            <small class="form-text text-muted">
                Upload an MP3 file. Maximum size 10MB.
            </small>
        </div>

        <div class="form-group mb-4">
            <label>Give us some details about the feedback you're looking for</label>
            <textarea class="form-control" v-model="track_description" style="height: 150px;" required></textarea>
            <small class="form-text text-muted">
                If you're looking for feedback on specific parts of the track please include
                timestamps here.
            </small>
        </div>

        <button class="btn btn-primary" @click="submitTrack" :disabled="isBusy">
            <span v-if="isBusy" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Submit track
        </button>
    </div>
</template>

<script>
export default {
    props: {
        artist: {
            type: Object,
            default: null,
            required: true
        },
        feedbackProduct: {
            type: Object,
            default: null,
            required: true
        },
        enrolment: {
            type: Object,
            default: null,
            required: true
        },
    },

    data() {
        return {
            isAuth: false,
            user: {},
            isBusy: false,
            artist_name: '',
            track_description: '',
            track_file: null,
            track_name: '',
            hasErrors: false,
            errors: [],
        };
    },

    mounted() {
        if(window.virtuoso) {
            if(window.virtuoso.is_auth) {
                this.isAuth = true;
                this.user = window.virtuoso.user;
                this.artist_name = this.user.name;
            }
        }
    },

    methods: {
        onFileChanged(event) {
            this.track_file = event.target.files[0];
        },

        submitTrack() {
            this.isBusy = true;
            this.hasErrors = false;

            let formData = new FormData();
            formData.append('artist_name', this.artist_name);
            formData.append('track_name', this.track_name);
            formData.append('track_description', this.track_description);
            formData.append('track_file', this.track_file);

            axios.post(`/api/feedback_enrolment/${this.enrolment.id}/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if(response.data) {
                    location.reload(); // Refresh the page
                }
            }, (error) => {
                if(error.response.data) {
                    this.errors = error.response.data.errors;
                    this.hasErrors = true;

                    window.scrollTo(0,0);
                }
            }).finally(() => {
                this.isBusy = false;
            });
        }
    }
};
</script>
